import React from "react";
import AppState from "./model/AppState";
import Rodape from "./components/Rodape";
import ListaItens from "./components/ListaItens";
import BuscaInterna from "./components/BuscaInterna";
import ConteudoModel from "./model/ConteudoModel";
import BotaoVoltar from "./components/BotaoVoltar";
import LogUtil from "./util/LogUtil";
import StringUtil from "./util/StringUtil";

type DicasReceitasSalvasState = {
  carregando: boolean,
  busca: string,
  concluido: boolean,
};

class DicasReceitasSalvas extends React.Component<any, DicasReceitasSalvasState> {

  constructor(props: any) {
    super(props);

    this.setBuscaTexto = this.setBuscaTexto.bind(this);

    this.state = {
      carregando: false,
      busca: "",
      concluido: true,
    };
  }

  componentDidMount(): void {
    LogUtil.logPage("Dicas e receitas salvas");
  }

  setBuscaTexto(query: string): void {
    this.setState({ busca: query });
  }

  render(): any {
    let conteudos: ConteudoModel[] = AppState.getCurtidos();

    let { busca, concluido } = this.state;
    if (busca.length > 0) {
      busca = StringUtil.sanitize(busca);
      conteudos = conteudos.filter((c: ConteudoModel) => StringUtil.sanitize(c.tipo).indexOf(busca) > 0 ||
        (c.nome && StringUtil.sanitize(c.nome).indexOf(busca) > 0) ||
        (c.dificuldade && StringUtil.sanitize(c.dificuldade).indexOf(busca) > 0) ||
        (c.ingredientes && StringUtil.sanitize(c.ingredientes).indexOf(busca) > 0) ||
        (c.porcoes && StringUtil.sanitize(c.porcoes).normalize().indexOf(busca) > 0) ||
        (c.preparo && StringUtil.sanitize(c.preparo).indexOf(busca) > 0) ||
        (c.resumo && StringUtil.sanitize(c.resumo).indexOf(busca) > 0) ||
        (c.conteudo && StringUtil.sanitize(c.conteudo).indexOf(busca) > 0) ||
        (c.tempo_de_preparo && StringUtil.sanitize(c.tempo_de_preparo).indexOf(busca) > 0)
        );
    }

    return (
      <section className="lists has-footer">
        <div className="header">
          <BotaoVoltar titulo="Dicas e receitas salvas" />
        </div>
        <BuscaInterna setBuscaTexto={ this.setBuscaTexto }></BuscaInterna>
        <div ref="conts">
          { busca.length === 0 && conteudos.length === 0 &&
          <div className="product-group">
            <div className="products nobg" ref="items">
              <div className="items list">
                <div>
                  <p className="none title">Ops!</p>
                  <p className="none">Nenhum conteúdo foi <br/> favoritado até o momento.</p>
                </div>
              </div>
            </div>
          </div>
          }
          { (conteudos.length > 0 || busca.length > 0) &&
          <ListaItens conteudos={ conteudos } carregando={ this.state.carregando } concluido={concluido} parent={this}></ListaItens>
          }
        </div>
        <Rodape parent={this} ativo="Lista"></Rodape>
      </section>
    );
  }
}

export default DicasReceitasSalvas;
